<template>
    <div class="box">
        <div class="box-header d-gray" :class="{'p-b-xs': order.customTags && order.customTags.length >0}">
            <h6 class="text-muted _400 inline" style="vertical-align: middle;">
                <span v-if="order.name">{{order.name}}</span>&nbsp;
                <span v-if="!order.name">Brak nazwy</span>

            </h6>
            <span class="label text-white m-r-xs none-radius inline" v-if="order.tags.indexOf('own-pickup') != -1" >Odbiór własny</span>
            <a href="" @click.prevent="changeStatus" title="Zmień status">
                <OrderStatusSpan :order="order" />
            </a>

            <span class="label text-white" v-if="order.status == 'in-production' && order.production">{{ Math.round((order.production.progress || 0)*100) }}%</span>

            <div class="pull-right">
                <div class="btn-group primary-color order-btn-group">
                    <a class="nav-link btn btn-xs white none-radius m-r-md" title="Historia" @click="openHistoryModal">
                        <i class="material-icons md-18">archive</i> Historia
                    </a>

                    <a class="nav-link btn btn-xs white none-radius m-r-md" title="Edytuj" :class="{ 'active': isChange}" @click="edit">
                        <i class="material-icons md-18">edit</i> Edytuj
                    </a>
                    <a class="nav-link btn btn-xs white none-radius" title="Powiel zamówienie" @click.prevent="clone">
                        <i class="material-icons md-18">content_copy</i>
                    </a>
                    <a class="nav-link btn btn-xs white none-radius" title="Oznacz jako spakowane" :class="{ 'active disabled': order.status == 'pack'}" @click.prevent="confirmStatus('pack')">
                        <i class="material-icons md-18">archive</i>
                    </a>
                    <a class="nav-link btn btn-xs white none-radius" title="Oznacz jako gotowe do wysyłki" :class="{ 'active disabled': order.status == 'ready-to-send'}" @click.prevent="confirmStatus('ready-to-send')">
                        <i class="material-icons md-18">done_all</i>
                    </a>
                    <a class="nav-link btn btn-xs white none-radius" title="Oznacz jako wysłane" :class="{ 'active disabled': order.status == 'sent'}" @click.prevent="confirmStatus('sent')">
                        <i class="material-icons md-18">call_made</i>
                    </a>
                    <a class="nav-link btn btn-xs white none-radius" title="Oznacz jako anulowane" :class="{ 'active disabled': order.status == 'cancel'}" @click.prevent="confirmCancel('cancel')">
                        <i class="material-icons md-18">highlight_off</i>
                    </a>

                    <a class="nav-link btn btn-xs white none-radius" title="Zobacz historię wysłanych maili" @click.prevent="showMailsModal()">
                        <i class="material-icons md-18">mail</i>
                    </a>
                </div>
            </div>

        </div>
        <div class="m-l d-gray" v-if="order.customTags && order.customTags.length >0">
            Tagi: <span class="m-r-sm text-muted" v-for="t in order.customTags" :key=t>{{t}}</span>
        </div>
        <hr class="m-t-0 m-b-0">
        <div class="box-header d-gray p-b-sm p-t-sm p-x-0">

            <div class="invoice-boxes-container p-x" v-if="(order.clientNo && order.clientNo.length > 0) || (order.invoiceNo && order.invoiceNo.length > 0) || (order.advanceInvoiceNo && order.advanceInvoiceNo.length > 0) || (order.finalAdvanceInvoiceNo && order.finalAdvanceInvoiceNo.length > 0)">
                <div class="invoice-box" v-if="order.clientNo && order.clientNo.length > 0">
                    <div class="box m-b-0 p-a-sm client-no" style="line-height: 1;">
                        {{order.clientNo}}
                        <br><span class="text-muted" style="font-size: 0.7rem;">Numer zam. klienta</span>
                    </div>
                </div>
                <div class="invoice-box" v-if="order.invoiceNo && order.invoiceNo.length > 0">
                    <div class="box m-b-0 p-a-sm invoice-no" style="line-height: 1;">
                        {{order.invoiceNo}}
                        <br><span class="text-muted" style="font-size: 0.7rem;">Numer FV/PF</span>
                    </div>
                </div>
                <div class="invoice-box" v-if="order.advanceInvoiceNo && order.advanceInvoiceNo.length > 0">
                    <div class="box m-b-0 p-a-sm" style="line-height: 1; border: 1px solid #f0ad4e; background: rgba(240, 173, 78, 0.02);">
                        {{order.advanceInvoiceNo}}
                        <br><span class="text-muted" style="font-size: 0.7rem;">FV zaliczkowa</span>
                    </div>
                </div>
                <div class="invoice-box" v-if="order.finalAdvanceInvoiceNo && order.finalAdvanceInvoiceNo.length > 0">
                    <div class="box m-b-0 p-a-sm" style="line-height: 1; border: 1px solid #9c27b0; background: rgba(156, 39, 176, 0.02);">
                        {{order.finalAdvanceInvoiceNo}}
                        <br><span class="text-muted" style="font-size: 0.7rem;">FV zaliczkowa końcowa</span>
                    </div>
                </div>
                <div class="invoice-box" v-if="wfirmaWZFullName">
                    <div class="box m-b-0 p-a-sm" style="line-height: 1; border: 1px solid #607d8b; background: rgba(96, 125, 139, 0.02);">
                        {{wfirmaWZFullName}}
                        <br><span class="text-muted" style="font-size: 0.7rem;">WZ wFirma</span>
                    </div>
                </div>
            </div>
            <div v-if="(order.clientNo && order.clientNo.length > 0) || (order.invoiceNo && order.invoiceNo.length > 0) || (order.advanceInvoiceNo && order.advanceInvoiceNo.length > 0) || (order.finalAdvanceInvoiceNo && order.finalAdvanceInvoiceNo.length > 0) || wfirmaWZFullName">
                <hr class="m-b-sm m-t-sm">
            </div>
            <div class="row p-x">
                <div class="col-md-12">
                    <span class="pull-right primary-color m-l" v-if="order.customerNotifactionDate">
                        Data wysłana w mailu:
                        <span class="_500">{{order.customerNotifactionDate | moment("DD/MM/YYYY")}}</span>
                    </span>
                    <span class="pull-right primary-color">
                        Data zamówienia:
                        <span class="_500">{{order.created | moment("DD/MM/YYYY")}}</span>
                    </span>

                    <span class=" pull-right primary-color m-r">
                        <span class="m-r-xs"> TERMIN GOTOWOŚCI - TG:</span>
                        <span @click.prevent="softDeadlineModal" title="Zmień" v-if="order.softDeadline" class="_500 deadline-link">{{order.softDeadline | moment("DD/MM/YYYY")}}</span>
                        <span @click.prevent="softDeadlineModal" title="Dodaj" v-else class="deadline-link">brak</span>
                    </span>

                    <span class="pull-right primary-color m-r">
                        <span class="m-r-xs"> Termin dla klienta:</span>
                        <span @click.prevent="deadlineModal" title="Zmień" v-if="order.hardDeadline" class="_500 deadline-link">{{order.hardDeadline | moment("DD/MM/YYYY")}}</span>
                        <span @click.prevent="deadlineModal" title="Dodaj" v-else class="deadline-link">brak</span>
                    </span>

                    <span class="pull-right primary-color m-r">
                        <span class="m-r-xs"> Waluta:</span>
                        <a href="#" class="deadline-link" @click.prevent="changeOrderCurrency">{{ order.currency }}</a>
                        <span v-if="order.currency != 'PLN' && order.exchangeRate && order.exchangeRate != 1" class="text-muted"> (kurs: {{ 1 | money(order.currency) }} = {{ order.exchangeRate | money("PLN") }})</span>
                    </span>
                </div>

            </div>
        </div>
        <hr class="m-t-0 m-b-0">

        <div class="order-btn-group">
            <button v-for="tab in tabs" :key="tab.name" class="tab btn btn-sm none-radius" :class="{active: selectedTab == tab}" @click="selectedTab = tab">
                <span class="primary-color _400">{{ tab.name }}</span>
            </button>
        </div>

        <component v-if="selectedTab" :is="selectedTab.component" :order="order" />
    </div>
</template>
<script>
import OrderStatusSpan from './OrderStatusSpan.vue'
import ChangeOrderStatusModal from './Modals/ChangeOrderStatusModal.vue'
import GenericModal from '../GenericModal.vue';
import GenericListModal from '../GenericListModal.vue';
import Api from '../../Api.js';
import EventBus from '../../event-bus.js';

import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
import pl from 'vuejs-datepicker/dist/locale/translations/pl.js'
import { addWorkingDays, isWorkingDay } from '../../Utils.js';
import SystemUsersManager from '../../SystemUsersManager.js';
export default {
    name: 'OrderDetalis',
    props: {
        order: Object
    },
    components: {
        OrderStatusSpan,
        Datepicker
    },
    data: function () {
        return {
            pl: pl,
            isChange: false,
            procesing: false,
            wfirmaWZid: null,
            wfirmaWZFullName: null,

            selectedTab: null,
            tabs: [{
                name: "Treść zamówienia",
                component: () => import("./DetailsTab/OrderCart/OrderCart.vue")
            }, {
                name: "Produkcja zamówienia",
                component: () => import("./DetailsTab/OrderProduction/OrderProduction.vue")
            }, {
                name: "Zgłoszone zapotrzebowania",
                component: () => import("./DetailsTab/OrderDemands.vue")
            }, {
                name: "Spakowane pozycje",
                component: () => import("./DetailsTab/OrderPackInfo/CartPosesPacked.vue")
            }, {
                name: "Symulator pakowania",
                component: () => import("./DetailsTab/PackingSimulator/PackingSimulator.vue")
            }]
        }
    },
    created: function() {
        EventBus.$on('newZPAdded', this.getProdReqs);

        // jesli zam jest w produkcji to na start wyswietlamy wlasnie tą zakładkę
        if (this.order.status == "in-production") this.selectedTab = this.tabs[1];
        else this.selectedTab = this.tabs[0];

        Api.wFirma.warehouseDocuments.getByOrderId(this.order._id).then((res) => {
            this.wfirmaWZid = res.wfirmaId;
            this.wfirmaWZFullName = res.fullname;
        }).catch((error) => {
            console.error("Błąd pobierania danych wfirma dla zamówienia:", error);
        });
    },
    destroyed: function() {
        EventBus.$off('newZPAdded', this.getProdReqs);
    },

    methods: {
        change: function() {
            if (!this.order.name || this.order.name.length == 0) {
                this.$notify({ group: 'global', type: 'notification-error', text: 'Podaj nazwę zamówienia.' });
                return;
            }
            this.procesing = true;
            Api.order.setName(this.order._id, this.order.name).then((order) => {
                this.order.name = order.name;
                this.procesing = false;
                this.isChange = false;
            })
        },

        changeStatus: function(task) {
            this.$modal.show(ChangeOrderStatusModal, {
                order: this.order
            }, {
                draggable: true,
                clickToClose: false,
                resizable: true,
                height: 'auto',
                scrollable: true
            });
        },

        toogleTag: async function(tag) {
            if (!Array.isArray(this.order.tags)) this.order.tags = [];
            const idx = this.order.tags.indexOf(tag);
            if (idx == -1) this.order.tags.push(tag);
            else this.order.tags.splice(idx, 1);

            await Api.order.setTags(this.order._id, this.order.tags);
        },
        confirmCancel: async function(status) {
            const p = parseInt(this.order.production.progress * 100);
            const message = 'Czy na pewno chcesz oznaczyć te zamówienie jako anulowane? Zamówienie jest zrealizowane w ' + p + '%.' +
            'Razem z zamówioniem zostaną równiez usuniete "Zlecenia Produkcyjne", które nie zostały ukończone. Czy na pewno chesz wykonać tą akcje?';
            if (await this.$helpers.confirm(message)) {
                this.setStatus(status);
                // EventBus.$emit('removeAllZP');
                // this.removePRs();
            };
        },

        confirmStatus: async function(status) {
            let confirmMsg = null;
            if (status == 'sent' && this.order.status != 'ready-to-send') {
                confirmMsg = "Czy na pewno chcesz oznaczyć te zamówienie jako 'Wysłane'?";
            } else if (status == 'ready-to-send' && this.order.status == 'in-production') {
                confirmMsg = "Czy na pewno chcesz oznaczyć te zamówienie jako 'Gotowe do wysłania' mimo, że ma status 'W produkcji'?";
            } else if (status == 'pack') {
                confirmMsg = "Czy na pewno chcesz oznaczyć te zamówienie jako 'Spakowane'?";
            }

            if (confirmMsg != null) {
                if (await this.$helpers.confirm(confirmMsg)) {
                    this.setStatus(status);
                };
            } else {
                this.setStatus(status);
            }
        },

        setStatus: function(status) {
            Api.order.setStatus(this.order._id, status).then((order) => {
                this.order.status = order.status;
            });
        },

        async clone() {
            if (!await this.$helpers.confirm(`Czy na pewno chcesz sklonować to zamówienie?`)) return;

            try {
                const clonedOrder = await Api.order.clone(this.order._id);
                this.$router.push({ name: 'order-details', params: { id: clonedOrder._id } });
                this.$h.success('Zamówienie sklonowane pomyślnie.');
            } catch (error) {
                this.$h.commonApiError(error, true);
            }
        },

        async edit() {
            this.isChange = true;
            const changedOrder = await this.$modal2.show(() => import('./Modals/ChangeOrderNameModal.vue'), { orderToChange: this.order });
            if (changedOrder) Object.assign(this.order, changedOrder);
            this.isChange = false;
        },
        async removePRs() {
            // na razie tego nie uzywamy, poniewaz po anulowaniu ZO, backend sam usuwa zlecenia prod.
            try {
                const res = await Api.production.request.v3.search({
                    orderId: this.order._id,
                    getInfoAboutReservedIngredientsForPR: true,
                    open: true, // tylko nieukończone. Ukończone zostawiamy do celów historycznych
                    ingredientFor: null // tylko koncowe PRsy
                });
                const rawPRs = res.data;

                for (const pr of rawPRs) {
                    const deletePrs = await Api.production.request.v3.remove(pr._id);
                }
            } catch (error) {
                this.$h.commonApiError(error, true);
            }
        },

        async softDeadlineModal() {
            await this.$modal2.show(GenericModal, {
                title: "Zmień TERMIN GOTOWOŚCI - TG",
                schema: {
                    soft: {
                        label: "Termin",
                        type: "date"
                    },
                    hint: {
                        type: 'info',
                        label: "Termin gotowości zamówienia (TG) – data, do której produkcja musi być ukończona. Ustawienie TdK nadpisze ten termin automatycznie."
                    }
                },
                values: {
                    soft: this.order.softDeadline
                },
                validate: async (values) => {
                    if (!values.soft) return "Podaj Szacunkowy termin";
                    const softDeadlin = new Date(values.soft);
                    if (softDeadlin < new Date()) return "Szacunkowy termin nie może być wcześniejszy niż dzisiaj";

                    if (!isWorkingDay(softDeadlin)) {
                        return "Termin TG nie może przypadać na weekend, święto ani dzień wolny";
                    }

                    try {
                        await Api.order.save(this.order._id, { softDeadline: softDeadlin });
                        this.$h.success('Pomyślnie zapisano zmiany');
                    } catch (error) {
                        return error.message;
                    }
                }
            });
        },

        async deadlineModal() {
            const opt = await this.$modal2.show(GenericModal, {
                title: "Zmień termin dla klienta",
                schema: {
                    hard: {
                        label: "Termin",
                        type: "date"
                    },
                    hint: {
                        type: 'info',
                        label: "Zmiana tego terminu spowoduje ustawienie produkcji na dwa dni robocze wcześniej! Brak jakiejkolwiek wartości spowoduje usunięcie terminu dla klienta i pozostawienie produkcji bez zmian."
                    }
                },
                values: {
                    hard: this.order.hardDeadline
                },
                validate: async (values) => {
                    let hardDeadline = null;
                    if (values.hard) {
                        hardDeadline = new Date(values.hard);

                        const beginingOfDay = new Date();
                        beginingOfDay.setHours(0, 0, 0, 0);
                        if (hardDeadline < beginingOfDay) return "Termin dla klienta nie może być wcześniejszy niż dzisiaj";

                        if (!isWorkingDay(hardDeadline)) {
                            return "Termin dla klienta nie może przypadać na weekend, święto ani dzień wolny";
                        }
                    }

                    try {
                        const o = await Api.order.save(this.order._id, { hardDeadline: hardDeadline });
                        this.order.hardDeadline = hardDeadline;
                        if (hardDeadline) {
                            let daysOffset = -2;
                            if (this.order.deliveryType === 'odbior osobisty') daysOffset = -3;
                            else if (this.order.deliveryType === 'dowoz') daysOffset = -4;
                            const productionDeadline = addWorkingDays(daysOffset, hardDeadline);
                            await Api.production.request.v3.changeDedlineForPrsGrupByOrderId(this.order._id, productionDeadline);

                            let tgOffset = 0;
                            if (this.order.deliveryType === 'odbior osobisty') tgOffset = -1;
                            else if (this.order.deliveryType === 'dowoz') tgOffset = -2;
                            const tg = addWorkingDays(tgOffset, hardDeadline);
                            await Api.order.save(this.order._id, { softDeadline: tg });
                            this.order.softDeadline = tg;
                        } else {
                            this.order.softDeadline = null;
                        }
                        this.$h.success('Pomyślnie zapisano zmiany');
                    } catch (error) {
                        return error.message;
                    }
                }
            });
        },

        async openHistoryModal() {
            const isSuccess = await this.$modal2.show(() => import("./Modals/ChangesHistoryModal.vue"), {
                order: this.order
            });
        },

        async changeOrderCurrency() {
            const opt = await this.$modal2.show(GenericModal, {
                title: "Edycja waluty zamówienia",
                schema: {
                    currency: {
                        label: "Waluta",
                        type: "select",
                        options: [
                            { id: "PLN", label: "PLN" },
                            { id: "EUR", label: "EUR" },
                            { id: "USD", label: "USD" }
                        ]
                    },
                    exchangeRate: {
                        label: "Kurs wymiany",
                        type: "number"
                    }
                },
                values: {
                    currency: this.order.currency,
                    exchangeRate: this.order.exchangeRate
                }
            });
            if (!opt) return;

            this.order.currency = opt.currency;
            this.order.exchangeRate = opt.exchangeRate;

            try {
                await Api.order.save(this.order.id, {
                    currency: opt.currency,
                    exchangeRate: opt.exchangeRate
                });
            } catch (error) {
                this.$h.commonApiError(error, true);
            }
        },

        async showMailsModal() {
            await this.$modal2.show(GenericListModal, {
                title: "Historia wysłanych maili",
                data: async () => {
                    try {
                        const res = await Api.mailer.history.get({
                            intentId: this.order._id,
                            intentType: 'order',
                        });
                        return res.data;
                    } catch (error) {
                        this.$h.commonApiError(error, true);
                        return [];
                    }
                },
                keys: {
                    header: (element) => `Temat: ${element.subject}`,
                    body: (element) => `${element.mailBody}`,
                    footer: (element) => {
                        let html = `Data wysłania: ${moment(element.sentAt).format("DD/MM/YYYY HH:mm")}`;
                        if (element.userId) {
                            html += `<br/>Wysłane przez: ${SystemUsersManager.getName(element.userId)}`;
                        }
                        return html;
                    }
                }
            });
        },

    }
}
</script>
<style scoped lang="scss">
.order-btn-group {
    display: flex;
    .tab {
        flex-grow: 1;
        background-color: var(--dm-surface-2, #f6f8f8);
        &.active {
            // color: rgba(255, 255, 255, 0.87);
            background-color: var(--dm-surface, #fff);
            box-shadow: none;
        }
    }
}

.deadline-link {
    cursor: pointer;
}
.deadline-link:hover {
    color: #2196f3;
}
.invoice-boxes-container {
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem;
}

.invoice-box {
    flex: 1 1 calc(50% - 0.375rem);
    min-width: 250px;
}

.client-no {
    border: 1px solid #90c844;
    font-size: 0.8rem;
    background: rgba(144, 200, 68, 0.02);
}
.invoice-no {
    border: 1px solid #5bc0de;
    font-size: 0.8rem;
    background: rgba(91, 192, 222, 0.02);
}

</style>
